export default function NavBar() {
  const navLinks = [
    { label: "Inicio",      href: "#inicio" },
    { label: "Acerca",      href: "#acerca" },
    { label: "Proyectos",   href: "#proyectos" },
    { label: "Contacto",    href: "#contacto" },
  ];

  return (
    <nav className="pf-navbar">
      <a href="#inicio" className="pf-navbar__brand" aria-label="rlodev — Inicio">
        <img src="/rlodev-badge-full.svg" alt="rlodev" className="pf-navbar__logo" />
      </a>
      <ul className="pf-navbar__links">
        {navLinks.map(({ label, href }) => (
          <li key={href}>
            <a href={href} className="pf-navbar__link">{label}</a>
          </li>
        ))}
        <li>
          <a href="/CV_Ricardo_Lopez.pdf" download className="pf-navbar__link pf-navbar__link--cv">
            CV
          </a>
        </li>
      </ul>
    </nav>
  );
}
